import { Lock } from "@phosphor-icons/react";

// What "private" does and doesn't do. Kept in one place so Setup, Quick meeting and the closing screen agree.
export const PrivateToggle = ({ value, onChange, testid = "private-toggle", compact = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={value}
    onClick={() => onChange(!value)}
    className={`inline-flex items-center gap-2 border transition-colors ${compact ? "h-8 px-2.5 text-xs" : "h-[42px] px-3.5 text-sm"} font-semibold ${value ? "border-[var(--o-warn)] text-[var(--o-warn)] bg-[color-mix(in_srgb,var(--o-warn)_10%,transparent)]" : "border-[var(--o-border)] text-[var(--o-muted)] hover:text-[var(--o-fg)] hover:border-[var(--o-border-strong)]"}`}
    data-testid={testid}
  >
    <Lock size={compact ? 13 : 15} weight={value ? "fill" : "regular"} aria-hidden="true" />
    Private meeting {value ? "· on" : ""}
  </button>
);

export const PrivateNote = ({ idleMinutes = 30, full = false }) => (
  <div className="text-xs text-[var(--o-muted2)] leading-relaxed space-y-1.5 max-w-2xl" data-testid="private-note">
    <p>
      <b className="text-[var(--o-fg)]">Nothing from this meeting is saved by Observer.</b> No transcript, answers or meeting log are kept on the server or in this browser. It is wiped when you press End, or after {idleMinutes} minutes with no page open.
      {!full && " The AI services you use still receive the audio and text."}
    </p>
    {full && (
      <>
        <p>Audio and text are still sent to the AI services you have set up (Gemini, Anthropic, ElevenLabs and so on) to be processed, under their own retention rules.</p>
        <p>Private meetings can&rsquo;t be scored or downloaded, don&rsquo;t survive a server restart, and aren&rsquo;t available for replays or for saving a briefing.</p>
        <p>Turn Private on before typing the briefing. A draft saved earlier can linger in this browser&rsquo;s storage until the browser tidies it up.</p>
      </>
    )}
  </div>
);
